const axios = require('axios');

const Getter = () => {
    function getExcerptJsx(html, project, keyword) {
        let _html = html.trim()
        const i = _html.toLowerCase().indexOf(`${project.toLowerCase()} |`)
        if (i > -1) _html = _html.substr(i + `${project.toLowerCase()} |`)

        const startContent = 'Awards & Nominations'
        let j = _html.indexOf(startContent)
        if (j > -1) {
            return _html.substr(j + startContent.length, 150)
        } else {
            const index = _html.toLowerCase().indexOf(keyword.toLowerCase())
            if (index > -1) {
                return _html.substr(index, 150)
            } else {
                return _html.substr(0, 150)
            }
        }
    }

    function getFromArray(keyword, arr){
        const projects = []
        arr.forEach(function (snapshot) {
            const { links, content, name } = snapshot;

            projects.push({
                ...snapshot,
                links: links && links.filter(k => !isLinkBacklist(k)),
                excerpt: content && getExcerptJsx(content, name, keyword)
            });
        });
        return projects
    }

    function getFromMySqlByKeyword(login, keyword, page, callback) {
        const url = `${process.env.REACT_APP_HOST}/projects/${keyword}/50/${page}`;

        axios(
            {
                method: 'get',
                url,
                auth: login
            })
            .then(function (response) {
                const res = response.data;
                if (res.error) {
                    callback({
                        error: res.error
                    })
                } else {
                    const projects = getFromArray(keyword, res.projects);                   

                    callback({
                        projects,
                        page: res.page,
                        nbPages: res.nPages
                    })
                }

            })
            .catch(function (error) {
                console.log('error', error)
                callback({ error })
            });
    }

    function isLinkBacklist(link) {
        return [
            'http://creativecommons.org/licenses/by/3.0',
            'http://creativecommons.org/licenses/by-sa/3.0'
        ].indexOf(link) > -1
    }

    function updateToMySql(login, project, callback) {
        const url = `${process.env.REACT_APP_HOST}/project/${project.id}`;
        project.content = project.content.replace(/'/gi, '');
        project.content_raW = project.content_raW.replace(/'/gi, '');

        axios(
            {
                method: 'put',
                url,
                auth: login,
                data: project
            })
            .then(function (response) {
                const res = response.data;
                if (res.error) {
                    callback({
                        error: res.error
                    })
                } else {
                    callback(res);
                }
            })
            .catch(function (error) {
                console.log('error', error)
                callback({ error })
            });
    }

    function deleteToMySql(login, id, callback) {
        const url = `${process.env.REACT_APP_HOST}/project/${id}`

        axios(
            {
                method: 'delete',
                url,
                auth: login,
                data: {id}
            })
            .then(function (response) {
                const res = response.data;
                if (res.error) {
                    callback({
                        error: res.error
                    })
                } else {
                    callback(res);
                }
            })
            .catch(function (error) {
                console.log('error', error)
                callback({ error })
            });
    }

    return {
        getFromArray,
        getFromMySqlByKeyword,
        updateToMySql,
        deleteToMySql
    }
}

export default Getter()